import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useHouseholdExpensesChartsDataContext } from './hooks/useHouseholdExpensesChartsDataContext';

export const EletricEnergy = () => {
    const { chartData } = useHouseholdExpensesChartsDataContext();

    return (
        <SimpleBars
            title={'Energia Elétrica'}
            horizontal={true}
            subtitles={chartData?.eletricEnergy?.map((item) => item.description)}
            values={chartData?.eletricEnergy?.map((item) => item.total  ||  0)}
            className='aligned-container'
        />
    );
};
